  <template>
  <div class="users-style">
	<b>Approved Payruns</b>
	<table class="table table-bordered table-striped table-hover">
	  <thead>
		<tr>
		  <td><input class="form-control" type="text" v-model="search.name" placeholder="Pay Run"@input="setSearch()"></td>
		  <td><input class="form-control" type="text" v-model="search.check_date" placeholder="Check Date"@input="setSearch()"></td>
		  <td><input class="form-control" type="text" v-model="search.month" placeholder="Month"@input="setSearch()"></td>
		  <td><input class="form-control" type="text" v-model="search.year" placeholder="Year"@input="setSearch()"></td>
		  <td><input class="form-control" type="text" v-model="search.earnings" placeholder="Earnings"@input="setSearch()"></td>
		  <td><input class="form-control" type="text" v-model="search.taxes" placeholder="Taxes"@input="setSearch()"></td>
		  <td><input class="form-control" type="text" v-model="search.deductions" placeholder="Deductions"@input="setSearch()"></td>
		  <td><input class="form-control" type="text" v-model="search.total_pay" placeholder="Total Pay"@input="setSearch()"></td>
		</tr>
	  </thead>
	  <tbody>
		<tr v-for="prun in payruns" :key="prun.id">
		  <td><a :href="$api_url+'/payrun-payslips/'+prun.id+''">{{prun.name}}</a></td>
		  <td>{{prun.check_date}}</td>
		  <td>{{prun.month}}</td>
		  <td>{{prun.year}}</td>
		  <td>{{prun.earnings}}</td>
		  <td>{{prun.taxes}}</td>
		  <td>{{prun.deductions}}</td>
		  <td>{{prun.total_pay}}</td>
		  </td>
		</tr>
	  </tbody>
	  <tfoot>
		<tr>
		  <td colspan="5"><span class="page-stats">{{pagination.from}} - {{pagination.to}} of {{pagination.total}}</span>
			<button v-bind:class="'btn btn-sm pagination-next btn-primary '+pagination.prebuttonstatus" @click="setPagination(false)" > Prev </button>
			<button v-bind:class="'btn btn-sm pagination-next btn-primary '+pagination.nextbuttonstatus"   @click="setPagination(true)"> Next </button>
			<select class="input" type="text" v-model="per_page" @change="setSearch()">
			  <option value="5">5</option>
			  <option value="10">10</option>
			  <option value="20">20</option>
			</select></td>
		</tr>
	  </tfoot>
	</table>
  </div>
  </template> 
  <script>
	  export default{
		  props: [],
		  mounted() {
			  console.log('started..');            
		  },
		  data(){
			  return {
				  payruns : [],  
				  employees : [],              
				  pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
				  search:{employee_id:'', pay_slip_name:'', pay_slip_ref:'', fiscal_year:'', month:''},
				 // search_by_id:{company_employee:''},
				  per_page:10,                
				  
  
			  }
		  },
		  methods:{
		  
			
			  setSearch: function(pageflg)
			  {
				  this.pagination.currentPage = 1;
				  this.getpayruns();
			  },
			  setPagination: function(pageflg)
			  {                
				  if(pageflg)
					  this.pagination.currentPage = this.pagination.nextPage;
				  else    
					  this.pagination.currentPage = this.pagination.prevPage;
				  
				  this.getpayruns();
			  },
			  getpayruns: function()
			  {
  
						  axios.get(this.$api_url+'/list-payruns/1' , {
							  params: {
								  page: this.pagination.currentPage,
								  per_page: this.per_page,
								  search_query: this.search,
								  search_query_by_id: this.search_by_id,
							  }
					  }).then(function(response){
					  this.payruns = response.data.data;
  
					  this.pagination.from = response.data.from;
					  this.pagination.to = response.data.to;
					  this.pagination.total = response.data.total;
					  
					  if(this.pagination.to==this.pagination.total)
					  {
						  
						  this.pagination.nextbuttonstatus = 'disabled';
						  
					  }
					  else
					  {
						   this.pagination.nextbuttonstatus = '';
					  }
					  
					  if(this.pagination.from==1)
					  {
					  this.pagination.prebuttonstatus = 'disabled';
					  }
					  else
					  {
						 this.pagination.prebuttonstatus = ''; 
					  }
  
  
  
					  if(this.pagination.currentPage < response.data.last_page)
						  this.pagination.nextPage = this.pagination.currentPage + 1;
  
					  if(this.pagination.currentPage == 1)
						  this.pagination.prevPage = 1;
					  else 
						  this.pagination.prevPage = this.pagination.currentPage - 1;
				  }.bind(this));
			  },
			 
  
  
		  },
		  created: function(){
			  this.getpayruns();
		
		  }
	  }
  </script>
  <style>
  button.disabled{
	  cursor: default;
  }
  
  </style>